var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"outer-container",attrs:{"id":"BookSuite"}},[_c('div',{attrs:{"id":"BookSuite-selector"}}),_c('iframe',{attrs:{"src":_vm.iframeSrc,"frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }